<template>
  <Head :title="`Consulta tu estado de cuenta`" />
  <div class="min-h-screen bg-gradient-to-br from-teal-100 to-white flex flex-col items-center py-8">
    <div class="w-full max-w-md bg-white rounded-2xl shadow-lg border border-teal-100 p-6">
      <!-- Logo -->
      <div class="flex flex-col items-center mb-6">
        <img src="/logo.png" alt="Logo" class="h-16 w-auto mb-4" />
        <h1 class="text-2xl font-bold text-teal-800 text-center">Consulta tu Estado de Cuenta</h1>
        <p class="text-gray-500 text-center mt-2">
          Ingresa tu número de identificación para ver tu estado de
          cuenta
        </p>
      </div>

      <!-- Formulario de búsqueda -->
      <form class="space-y-4" @submit.prevent="search">
        <div>
          <label for="identification" class="block text-sm font-medium text-gray-700 mb-1">
            Número de Identificación
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <i class="fa fa-id-card text-gray-400" />
            </div>
            <input
              id="identification" v-model="form.identification" type="text"
              class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500"
              placeholder="Ej: V-12345678" :class="{ 'border-red-500': form.errors.identification }"
            />
          </div>
          <p v-if="form.errors.identification" class="mt-1 text-sm text-red-600">
            {{ form.errors.identification }}
          </p>
        </div>

        <button
          type="submit"
          class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
          :disabled="form.processing"
        >
          <span v-if="form.processing">
            <i class="fa fa-spinner fa-spin mr-2" />
            Buscando...
          </span>
          <span v-else>
            <i class="fa fa-search mr-2" />
            Consultar Estado de Cuenta
          </span>
        </button>
      </form>

      <!-- Mensaje de error -->
      <div v-if="error" class="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <i class="fa fa-exclamation-circle text-red-400" />
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-red-800">
              No se encontró la cuenta
            </h3>
            <div class="mt-2 text-sm text-red-700">
              <p>Verifica que el número de identificación sea correcto.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center text-gray-400 text-xs mt-8">
        Si tienes problemas para acceder, contacta a tu vendedor.
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
export default {
  components: {
    Head,
  },
  props: {
    account: Object,
  },
  data() {
    return {
      error: false,
      form: this.$inertia.form({
        identification: '',
      }),
    }
  },
  methods: {
    search() {
      this.error = false
      this.form.get(`/public/client/${this.form.identification}${this.account ? '?account='+this.account.id : ''}`, {
        onError: () => {
          this.error = true
        },
      })
    },
  },
}
</script>